import { NgModule } from '@angular/core';
import { VirtualProductListComponent } from './virtual-product-list/virtual-product-list.component';
import { VirtualProductItemComponent } from './virtual-product-item/virtual-product-item.component';
import { VirtualProductGroupComponent } from './virtual-product-group/virtual-product-group.component';
import { InventoryEventsDirectiveModule, NgForTrackByUuidDirectiveModule } from '@shared/directives';

import { CommonModule } from '@angular/common';
import { VirtualScrollerModule } from '@core/capacitor-plugins/capacitor-plugins.class';

@NgModule({
  imports: [CommonModule, VirtualScrollerModule, InventoryEventsDirectiveModule, NgForTrackByUuidDirectiveModule],
  declarations: [VirtualProductListComponent, VirtualProductItemComponent, VirtualProductGroupComponent],
  exports: [VirtualProductListComponent],
})
export class VirtualProductListComponentModule {}
